import SEO from '../components/SEO';
import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="Privacy Policy | Ascarii"
        description="Privacy policy and GDPR compliance information for Ascarii. How we handle your data, cookies, and information security."
        keywords="privacy policy, GDPR compliance, data protection, cookie policy"
      />

      <section className="py-20 bg-gradient-to-br from-blue-600 via-sky-700 to-cyan-600">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">Privacy Policy</h1>
            <p className="text-xl text-blue-100">How we protect and use your information</p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 lg:px-8 max-w-4xl">
          <div className="prose prose-lg max-w-none">
            <div className="bg-gradient-to-br from-slate-50 to-white rounded-2xl p-8 border border-gray-200 mb-8">
              <p className="text-gray-700 leading-relaxed">Ascarii Limited is committed to protecting your privacy. This policy explains how we collect, use, and protect your personal information in accordance with GDPR and UK data protection laws.</p>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Information We Collect</h2>
            <p className="text-gray-700 mb-4">We may collect the following information:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
              <li>Name, job title, and contact information (email, phone)</li>
              <li>Company details and business requirements</li>
              <li>Technical information (IP address, browser type, usage data)</li>
              <li>Information you provide in forms, emails, or support requests</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">How We Use Your Information</h2>
            <p className="text-gray-700 mb-4">We use your information to:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
              <li>Respond to your enquiries and provide requested services</li>
              <li>Send you relevant information about SAP Business One and our services</li>
              <li>Improve our website and services</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Data Protection</h2>
            <p className="text-gray-700 mb-4">We implement appropriate technical and organisational measures to protect your personal data against unauthorised access, loss, or misuse. Your data is stored securely and we never sell your information to third parties.</p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Your Rights</h2>
            <p className="text-gray-700 mb-4">Under GDPR, you have the right to:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to processing</li>
              <li>Data portability</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Cookies</h2>
            <p className="text-gray-700 mb-4">We use cookies to improve your experience on our website. You can control cookie settings through your browser preferences.</p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Data Retention</h2>
            <p className="text-gray-700 mb-4">We retain your personal data only for as long as necessary to fulfill the purposes for which it was collected or as required by law.</p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Changes to This Policy</h2>
            <p className="text-gray-700 mb-4">We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated revision date.</p>

            <div className="bg-blue-50 rounded-xl p-6 border border-blue-200 mt-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Contact Us About Privacy</h3>
              <p className="text-gray-700 mb-2">If you have questions about this Privacy Policy or wish to exercise your data rights:</p>
              <p className="text-gray-700">Email: <a href="mailto:info@ascarii.com" className="text-blue-600 hover:underline">info@ascarii.com</a></p>
              <p className="text-gray-700 mt-2">Ascarii Limited, NETPark, Thomas Wright Way, Sedgefield, County Durham, TS21 3FD</p>
            </div>

            <p className="text-sm text-gray-500 mt-8">Last updated: October 2025</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
